import { OK } from 'http-status-codes'
import getAxiosInstance from '../../helpers/get_axios_instance'

export class Histograma {
  static getHistogramaVolcadora (fechaD, fechaH) {
    const axios = getAxiosInstance()
    const filtro = `{"clave":{"fecha_desde": "${fechaD}", "fecha_hasta": "${fechaH}"}}`
    const promise = axios.get(`/histograma_volcado_volcadora_listado?r=${filtro}`)
    return promise.then((result) => {
      const { status, data } = result
      if (status !== OK) throw new Error('No se pudo obtener el histograma de volcadoras.')
      return data
    })
  }

  static getHistogramaIngresoPorUsuario (fechaD, fechaH) {
    const axios = getAxiosInstance()
    const filtro = `{"clave":{"fecha_desde": "${fechaD}", "fecha_hasta": "${fechaH}"}}`
    const promise = axios.get(`histograma_ingreso_usuario_listado?r=${filtro}`)
    return promise.then((result) => {
      const { status, data } = result
      if (status !== OK) throw new Error('No se pudo obtener el histograma de ingreso por usuario.')
      return data
    })
  }

  static getHistogramaIngresoPorCereal (fechaD, fechaH) {
    const axios = getAxiosInstance()
    const filtro = `{"clave":{"fecha_desde": "${fechaD}", "fecha_hasta": "${fechaH}"}}`
    const promise = axios.get(`histograma_ingreso_cereal_entre_fechas?r=${filtro}`)
    return promise.then((result) => {
      const { status, data } = result
      if (status !== OK) throw new Error('No se pudo obtener el histograma de ingreso por cereal.')
      return data
    })
  }

  static getHistogramaBalanzaBruto (fechaD, fechaH) {
    const axios = getAxiosInstance()
    const filtro = `{"clave":{"fecha_desde": "${fechaD}", "fecha_hasta": "${fechaH}"}}`
    const promise = axios.get(`histograma_pesado_bruto_balanza_listado?r=${filtro}`)
    return promise.then((result) => {
      const { status, data } = result
      if (status !== OK) throw new Error('No se pudo obtener el histograma de pesado bruto.')
      return data
    })
  }

  static getHistogramaCalado (fechaD, fechaH) {
    const axios = getAxiosInstance()
    const filtro = `{"clave":{"fecha_desde": "${fechaD}", "fecha_hasta": "${fechaH}"}}`
    const promise = axios.get(`histograma_analisis_calado_puesto_listado_entre_fechas?r=${filtro}`)
    return promise.then((result) => {
      const { status, data } = result
      if (status !== OK) throw new Error('No se pudo obtener el histograma de pesado bruto.')
      return data
    })
  }

  static getHistogramaBalanzaDestare (fechaD, fechaH) {
    const axios = getAxiosInstance()
    const filtro = `{"clave":{"fecha_desde": "${fechaD}", "fecha_hasta": "${fechaH}"}}`
    const promise = axios.get(`histograma_pesado_destare_balanza_listado?r=${filtro}`)
    return promise.then((result) => {
      const { status, data } = result
      if (status !== OK) throw new Error('No se pudo obtener el histograma de pesado destare.')
      return data
    })
  }
}
